import {Injectable} from '@angular/core';
import {AuthService} from './auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private authService: AuthService) {}

  isRole(role: string | string[]): boolean {
    const authorities = this.authService.decodeToken('authorities');
    if (typeof role === 'string') {
      return authorities.includes(role);
    } else {
      return role.some(r => authorities.includes(r));
    }
  }
}
